import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../lib/webApi';
import { probeCoachChatEnabled } from '../../shared/coachChatClient.mjs';

let cachedCoachEnabled = null;
let probePromise = null;

/**
 * Boot-time probe: hide Expert coach nav when API returns 503.
 */
export function useCoachChatAvailable() {
  const [available, setAvailable] = useState(false);
  const [checked, setChecked] = useState(false);

  const runProbe = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      cachedCoachEnabled = false;
      setAvailable(false);
      setChecked(true);
      return;
    }
    if (cachedCoachEnabled !== null) {
      setAvailable(cachedCoachEnabled);
      setChecked(true);
      return;
    }
    if (!probePromise) {
      probePromise = probeCoachChatEnabled((url, init) =>
        apiFetch(url, init),
      ).then((enabled) => {
        cachedCoachEnabled = enabled;
        probePromise = null;
        return enabled;
      });
    }
    const enabled = await probePromise;
    setAvailable(enabled);
    setChecked(true);
  }, []);

  useEffect(() => {
    void runProbe();
  }, [runProbe]);

  return { coachChatAvailable: available, coachChatChecked: checked };
}

export function resetCoachChatAvailabilityCache() {
  cachedCoachEnabled = null;
  probePromise = null;
}

/** @deprecated use resetCoachChatAvailabilityCache */
export function resetCoachChatAvailabilityCacheForTests() {
  resetCoachChatAvailabilityCache();
}
